import React from "react";
import "../css/returns.scss";

function Returns() {
  return (
    <div className="returns">
      <div className="policy-container">
        <h1>Refund Policy</h1>

        <h2>Online & In-Store Returns Policy</h2>
        <p>
          At isanroute, we take great care to ensure all products leave our
          store in perfect condition. If for any reason you need to return an
          item, please ensure it is in the same condition as when you received
          it - unworn, unwashed, unaltered, and with all original tags and
          packaging intact.
        </p>
        <p>
          If you are not fully satisfied with your purchase, you may return it
          within <strong>28 days</strong> of receipt for an exchange, store
          credit, or refund. Please note that refunds do not include the
          original postage and packaging costs. Items that show signs of wear,
          washing, or damage will not be accepted.
        </p>

        <h2>Returns by post</h2>
        <p>
          Return shipping must be covered by the
          customer. We recommend using a reliable, trackable service via your
          local postal carrier or preferred courier.
        </p>
        <p>Return address:</p>
        <p>
          <strong>isanroute</strong>
          <br />
          9 Essex Street East
          <br />
          Dublin
          <br />
          D02 RW53
          <br />
          Ireland
        </p>

        <h2>Returns Terms & Guidelines</h2>
        <ul>
          <li>
            All returned items must be{" "}
            <strong>
              unworn, unwashed, and complete with original tags and packaging
            </strong>
            .
          </li>
          <li>
            The{" "}
            <strong>customer is responsible for return shipping costs</strong>,
            unless the item is faulty or incorrect.
          </li>
          <li>
            Please ensure all returns are <strong>securely packaged</strong> to
            avoid damage in transit.
          </li>
          <li>
            For footwear, please place the{" "}
            <strong>shoe box inside protective outer packaging</strong>. The box
            is part of the product, and any damage may result in refusal of the
            return.
          </li>
          <li>
            All packages should be{" "}
            <strong>sent with a trackable, insured service</strong> — we cannot
            take responsibility for items lost or damaged in return transit.
          </li>
          <li>
            Where customs documentation is required, mark your package
            <strong> "RETURNED GOODS"</strong>. isanroute is not responsible
            for fees caused by incomplete or incorrect declarations.
          </li>
        </ul>
        <p>
          Once received and inspected, your refund or exchange will be processed
          within <strong>5–10 working days</strong> via the original payment
          method.
        </p>
      </div>
    </div>
  );
}

export default Returns;
